<script>
import addDotsInNumber from '../../../../js/util/addDotsInNumber';

export default {
  computed: {
    rentalType() {
      return this.$store.state.filters.properties.rentalType;
    },
    houseCount() {
      return this.$store.state.houseCount;
    },
    loginHouseCount() {
      return this.$store.state.loginHouseCount;
    },
    houseCountExpected() {
      return this.$store.state.houseCountExpected;
    },
    rentalTypesUntranslated() {
      return this.$store.state.rentalTypesUntranslated;
    },
    location() {
      return this.$store.state.filters.location.location;
    },
    suggestType() {
      return this.$store.state.filters.location.suggestType;
    },
  },
  methods: {
    addDotsInNumber(num) {
      return addDotsInNumber(num);
    },
    // capitalize first letter in string
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // return the translated name 'results' in plural or single
    resultsName(count) {
      return this.$t('messages_nl.global.results', {'count': count});
    },
    // return the translated rental type name in plural or single
    rentalTypeName(count = this.houseCount) {
      if (
          this.rentalType !== null
          && this.rentalType !== undefined
          && this.rentalTypesUntranslated[this.rentalType] !== null
          && this.rentalTypesUntranslated[this.rentalType] !== undefined
      ) {
        return this.$t('messages_nl.rental.typePluralOrNot.' + this.rentalTypesUntranslated[this.rentalType], {'count': count}).toLowerCase();
      }
      return this.$t('messages_nl.rental.typePluralOrNot.default', {'count': count}).toLowerCase();
    },
  },
}
</script>
